import { Timeline } from '@mui/icons-material'
import React from 'react'
import { pointsText } from 'utils/functions'

const DDScoreExpansibleTitle = ({ finalScore }) => (
  <span style={{ display: 'flex', alignItems: 'center' }}>
    <Timeline fontSize="small" style={{ marginRight: '0.4rem' }} />
    {`Score do Due Diligence: ${pointsText(finalScore)}`}
  </span>
)

export default DDScoreExpansibleTitle
